import { render, staticRenderFns } from "./roast.vue?vue&type=template&id=6f3d6670&"
import script from "./roast.vue?vue&type=script&lang=js&"
export * from "./roast.vue?vue&type=script&lang=js&"
import style0 from "./roast.vue?vue&type=style&index=0&id=6f3d6670&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports